import findAttachment from './findAttachment';
import type { AttachmentWellViewState } from 'owa-attachment-well-data';
import { CID_PREFIX, ORIGINAL_SRC_ATTRIBUTE } from '../utils/constants';
import {
    lazyLoadFromAttachment,
    lazyLoadFromAttachmentServiceUrl,
    lazyLoadFromProxy,
} from 'owa-inline-image-loader';

// The context used for inline image load (load from existing content, draft, forward etc.)
const CONTEXT_COMPOSE = 'Compose';
const CONTEXT_MOVEFROMATTACHMENTWELL = 'MoveFromAttachmentWell';
const IMG_CID_SRC_REGEX = /^cid:(\S+)/;
const DOWNLOAD_FROM_ATTACHMENT_DATASET_NAME = 'custom';
const DOWNLOAD_FROM_PROXY_DATASET_NAME = 'imageproxyendpoint';

export default async function loadImage(
    img: HTMLImageElement,
    viewState: AttachmentWellViewState,
    userIdentity?: string,
    onImageLoadSuccess?: (img: HTMLImageElement) => void,
    onImageLoadFailure?: (img: HTMLImageElement) => void
) {
    if (img.dataset[DOWNLOAD_FROM_ATTACHMENT_DATASET_NAME]) {
        // Load from attachment
        const loadFromAttachment = await lazyLoadFromAttachment.import();
        loadFromAttachment(
            img,
            CONTEXT_COMPOSE,
            false /* usePlaceHolder */,
            userIdentity,
            onImageLoadSuccess,
            onImageLoadFailure
        );
    } else if (img.dataset[DOWNLOAD_FROM_PROXY_DATASET_NAME]) {
        // load from image proxy
        const loadFromProxy = await lazyLoadFromProxy.import();
        await loadFromProxy(img);
    } else {
        const cid = img.getAttribute(ORIGINAL_SRC_ATTRIBUTE) || img.src;
        const match = IMG_CID_SRC_REGEX.exec(cid);

        if (match) {
            // Image src is a Content Id, try get image url from attachment store
            const attachment = findAttachment(viewState, { cidOrName: match[1] });
            const thumbnailImageUrl = attachment?.thumbnailImage?.url;
            const cid = attachment?.model.ContentId;

            if (cid) {
                img.setAttribute(ORIGINAL_SRC_ATTRIBUTE, CID_PREFIX + cid);
            }

            if (thumbnailImageUrl) {
                const loadFromAttachmentServiceUrl = await lazyLoadFromAttachmentServiceUrl.import();
                loadFromAttachmentServiceUrl(
                    img,
                    thumbnailImageUrl,
                    CONTEXT_MOVEFROMATTACHMENTWELL
                );
            }
        }
    }
}
